import { reverse } from "@reactivated";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { IWishListLine, WishListLines } from "../models/catalogue";
import { IProductAPIURL } from "../models/nominals";
import { check } from "../models/utils";
import { CSRF_HEADER, ajax, getCSRFToken } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

export const listLines = async (
    wishListCode: string,
): Promise<readonly IWishListLine[]> => {
    const mutex = new PromiseMutex<readonly IWishListLine[]>(
        `wishlist-products-list-${wishListCode}`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(reverse("wishlisttype-line-list", { code: wishListCode }))
            .set("Accept", "application/json")
            .then((resp) => {
                return check(WishListLines.decode(resp.body));
            });
        mutex.setPromise(loading);
    }
    return loading;
};

export const addLine = async (
    wishListCode: string,
    lineURL: IProductAPIURL,
): Promise<unknown> => {
    const window = getWindow();
    const origin = window?.location.origin || "";
    const data = {
        list_type: `${origin}${reverse("wishlisttype-detail", { code: wishListCode })}`,
        product: lineURL,
    };
    return ajax
        .post(reverse("wishlisttype-line-list", { code: wishListCode }))
        .set("Accept", "application/json")
        .set(CSRF_HEADER, await getCSRFToken())
        .send(data)
        .then((resp) => {
            return resp;
        });
};

export const removeLine = async (lineURL: string): Promise<boolean> => {
    return ajax
        .del(lineURL)
        .set("Accept", "application/json")
        .set(CSRF_HEADER, await getCSRFToken())
        .then(() => {
            return true;
        });
};
